const noop = function () {
  return;
};

export default noop;
